<template>
  <div class="phone-container">
    <div class="highlight">
      <p class="speech-bubble">{{ $t('components.representative.speech-bubble') }}</p>
      <p class="instruction">{{ $t('components.representative.enter-phonenumber')}}</p>
      <PhoneInputContainer on-submit="instant-call" :buttonText="buttonText" />
    </div>
  </div>
</template>

<script>
import PhoneInputContainer from '@/components/SectionCalling/PhoneInputContainer.vue'
import CountriesMixin from '@/mixins/CountriesMixin.vue'
import { resolveJSON } from '@/helperfunctions'

export default {
  name: 'PhoneInput',
  components: {
    PhoneInputContainer
  },
  mixins: [CountriesMixin],
  props: {
    buttonText: String,
  },
}
</script>

<style lang=scss>
@import '@/assets/styles/_variable.scss';


.phone-container {
  .speech-bubble {
    font-size: 1.6em;
    line-height: 1.2em;
    margin: 0 0 .5em;
    font-weight: bold;
  }
  .instruction {
    margin: 0 0 .5em;
  }
}

</style>
